import Vue from 'vue';

import Notification from './Notification';

Vue.component('CustomNotification', Notification);

class Notifier {
  constructor() {
    this.emitter = new Vue();
  }
  emit(message, type, options = {}) {
    this.emitter.$emit('globalNotifcations', Object.assign({}, options, { type, message }));
  }
  success(message, options = {}) {
    this.emit(message, 'success', options);
  }
  error(message, options = {}) {
    this.emit(message, 'error', options);
  }
  info(message, options = {}) {
    this.emit(message, 'info', options);
  }
  warning(message, options = {}) {
    this.emit(message, 'warning', options);
  }
}

window.Notify = new Notifier();
